module.exports = __webpack_public_path__ + "img/mediagate-logo.413d1039.png";